<template>
    <span><a :tabindex="tabIndex"
             ref="link"
             :href="disabled ? undefined : targetLink"
             :style="linkStyle"
             v-tooltip="tooltip"
             @click="onClick"
             @keydown.enter="onClick"
    ><slot>{{ $cutName(target.name, cutName) }}</slot></a><span
            v-if="postfixLabel">{{ postfixLabel }}</span></span>
</template>

<script>
    import SimpleLinkMixin from './SimpleLinkMixin';
    import RouterCheckAvailabilityMixin from "./RouterCheckAvailabilityMixin";

    export default {
        name: "SimpleLink",
        mixins: [SimpleLinkMixin, RouterCheckAvailabilityMixin],
        props: {
            color: {
                type: String,
                required: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            }
        },
        computed: {
            availableInRouter() {
                return this.getRouterAvailability(this.target.link);
            },
            linkStyle() {
                const stl = {};
                if (this.color) {
                    stl.color = this.color;
                }
                if (this.disabled) {
                    stl.cursor = 'not-allowed';
                    stl.pointerEvents = 'none';
                    stl.opacity = '0.6';
                }
                return stl;
            },
        },
        methods: {
            onClick(e) {
                if (this.disabled) {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }
                if (this.availableInRouter) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.$router.push(this.targetLink);
                }
            },
        }
    };
</script>
